module.exports = __webpack_public_path__ + "static/media/Notification_Icon.099b7324.svg";